/**
 * This file is a part of King Living's projects.
 *
 * Copyright © King Living - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defaultsDeep} from 'lodash';

import {AbstractService} from '@amblique/base/shared/services/abstract-service';

/**
 * Custom Utils SCAPI service for whitelisted site client data.
 *
 * Fetches site client data via `/mobify/proxy/api` using the existing `c_amb.utils`
 * scope, avoiding storefront Cloudflare blocks on `Site-ClientData`.
 */
export class ConfigApiService extends AbstractService {
  /**
   * @returns {string}
   */
  static get name() {
    return 'ConfigApiService';
  }

  /**
   * @returns {object}
   */
  static get profile() {
    return defaultsDeep({
      baseUrl: '{origin}{app.commerceAPI.proxyPath}/custom/utils/v1/organizations/{commerceAPI.organizationId}',
      dynamicProperties: ['baseUrl'],
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    }, super.profile);
  }

  /**
   * @returns {string[]}
   */
  static get variables() {
    return ['app', 'commerceAPI', 'locale', 'origin', 'site'];
  }

  /**
   * Gets whitelisted site client data.
   *
   * @param {RequestInit} [request]
   *
   * @returns {Promise<{clientData: object}>}
   */
  async getSiteClientData(request) {
    const parameters = {
      siteId: this.variables.site.id,
    };

    if (this.variables.locale?.id) {
      parameters.locale = this.variables.locale.id;
    }

    return this.get('site-client-data', {
      parameters,
      ...request,
    });
  }
}
